<template>
  <div class="index">
    <div class="container banner">
      <div class='page_width'>
        <div class="banner_left">
          <div class="left_top"> Where Imagination Meets Reality</div>
          <div class="left_bottom">Beyond Gaming</div>
        </div>
        <div class="banner_right">
          <img src="https://assets.g2g.com/ui/img/banners/G2G-banner-large.webp" alt="">
        </div>
      </div>
    </div>
    <div class="container" >
      <div class="page_width page_top page_full" >
     <div class="page_back">
      <div class="page_title">
          <div class="title_name">Trending Games</div>
          <div class="title_tab flex_content pointer">
            <!-- <div class="title_tab_text">Discover all</div> -->
            <!-- <div class="title_tab_icon iconfont icon-circle_chevron_right flex_content"></div> -->
          </div>
        </div>
        <div class="page_thumb cate_thumb">
          <div class="page_container cate_container">
            <swiper :options="swiperOption2" ref="mySwiper2" class="swiper_cate">      
                <swiper-slide class="slide_cate" v-for="(i,index) in videoGame" :key="index">
                  <div class="cate_tab pointer" >     
                  <el-image :src="i.image" @click="toGame(i.url)">
                    <div slot="error" class="image-slot flex_content">
                      <i class="err_img">
                        <img src="../../assets/image/err.jpg" alt="">
                      </i>
                    </div>
                    <div slot="placeholder" class="image-slot flex_content">
                      Loading<span class="dot">...</span>
                    </div>
                  </el-image>
                  <!-- <div class="cate_tab_count">89 offers</div> -->
                  <div class="cate_tab_title">{{ i.name }}</div>
                  <div class="marks flex_col_content" @click="checkLock(i)" v-if="i.lock">
                    <div class="marks_lock">
                      <img src="../../assets/image/suo.png" alt="">
                    </div>
                    <div class="marks_price flex_content">{{i.icons}}
                      <i class="flex_content"><svg t="1727340443326" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16427" width="16" height="16"><path d="M627.297444 73.795726l-252.991991 12.929474-150.698211 114.16925L109.437993 398.642233v228.338498l114.169249 197.74676 143.422504 114.170272 281.55656 11.306511 184.30768-100.281961 128.715547-222.941582V398.642233L847.440283 200.89445z" fill="#D8AB15" p-id="16428"></path><path d="M605.815177 85.913718H377.476679L179.729919 200.082968 65.559647 397.830751v228.338498l114.170272 197.74676 197.74676 114.169249h228.338498l197.74676-114.169249 114.170273-197.74676V397.830751l-114.170273-197.747783z" fill="#F4DB33" p-id="16429"></path><path d="M321.538669 291.831578l478.853065-90.937128-193.627952 383.194402z" fill="#F4EE6D" p-id="16430"></path><path d="M372.082832 938.897763l-50.544163-647.066185L62.389444 626.980731l110.559025 191.495382z" fill="#F4D533" p-id="16431"></path><path d="M608.986403 584.088852L374.305453 938.897763h234.68095z" fill="#F4D835" p-id="16432"></path><path d="M914.560984 626.980731l-305.574581-42.891879v354.808911l191.405331-114.170272z" fill="#F4D735" p-id="16433"></path><path d="M323.76129 291.831578l285.225113 292.257274-234.68095 354.808911z" fill="#F3E044" p-id="16434"></path><path d="M330.289983 291.831578l44.01547-205.106378-197.74676 114.16925L62.389444 398.642233v228.338498z" fill="#F4D12E" p-id="16435"></path><path d="M800.391734 200.89445L914.560984 398.642233v228.338498l-305.574581-42.891879z" fill="#F4DF44" p-id="16436"></path><path d="M585.425801 861.990163H397.866055L235.435639 768.211313 141.655765 605.779873V418.220127l93.779874-162.430416 162.430416-93.779874h187.559746l162.43144 93.779874 93.77885 162.430416V605.779873l-93.77885 162.43144-162.43144 93.77885z m-181.092451-24.136724h174.624133l151.229306-87.311554 87.311555-151.229307V424.687422l-87.311555-151.229307-151.229306-87.312578H404.33335l-151.229307 87.312578-87.312578 151.229307v174.624133l87.312578 151.229306 151.229307 87.312578z" fill="#B16A23" opacity=".29" p-id="16437"></path><path d="M367.029746 938.897763l281.55656 11.306511 184.30768-100.281961-32.502252-25.194822-191.405331 114.170272z" fill="#BE8516" p-id="16438"></path><path d="M627.297444 73.795726l-21.482267 12.117992 197.74676 114.16925 43.878346 0.811482z" fill="#D2BD33" p-id="16439"></path><path d="M494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#F4D033" p-id="16440"></path><path d="M645.203256 498.961032L501.179049 650.448212c-8.208962 8.580422-13.431917 8.580422-16.790408 8.580423-2.986007 0-8.582469 0-16.417925-8.580423L323.947532 498.961032s0-0.37146-0.373507-0.37146c-4.103458-5.970992-6.343475-13.059434-6.343475-19.775392s2.238994-13.43294 6.343475-17.909905l72.38561-77.236082c3.730974-3.731998 6.715959-5.969968 9.327436-7.089465 2.986007-1.119497 5.223978-1.119497 6.715959-1.119497h145.143705c3.358491 0 5.596462 0.74599 8.208962 2.238994 2.611477 1.490957 4.476965 3.357468 7.461949 6.343475l72.384587 76.862575c0.373507 0 0.373507 0 0.373507 0.37146 4.103458 4.851495 5.969968 11.567453 5.969968 18.284435 0 7.460925-2.237971 14.923898-5.969968 19.029402-0.372483-0.001023-0.372483 0.37146-0.372484 0.37146zM494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#ECBF1D" p-id="16441"></path><path d="M417.600515 470.977701c-1.493004-1.865487-1.493004-5.222955 0.74599-6.715958 1.866511-1.866511 4.850471-1.493004 6.716982 0.373506l59.326177 69.774133 60.818157-69.774133c1.865487-1.865487 4.850471-2.238994 7.089465-0.373506 1.866511 1.866511 1.866511 4.850471 0.373507 6.715958l-64.550155 73.877591-0.74599 0.747014a4.793166 4.793166 0 0 1-6.716982-0.747014l-63.057151-73.877591z m0 0" fill="#F5EC67" p-id="16442"></path><path d="M627.297444 73.795726L377.476679 85.913718h228.338498z" fill="#BE8516" p-id="16443"></path></svg></i>
                    </div>
                  </div>
                </div>
                
              </swiper-slide>
            </swiper>
          </div>
          <div class="swiper-pagination pagination_state" slot="pagination"></div>
        </div>
     </div>
      </div>
    </div>
    <!-- <div class="container" v-if="giftCards.length>0">
      <div class="page_width page_top">
        <div class="page_title" style="color:#000">
          <div class="title_name">Trending Gift Cards</div>
          <div class="title_tab flex_content pointer">
            <div class="title_tab_text">Discover all</div>
            <div class="title_tab_icon iconfont icon-circle_chevron_right flex_content"></div>
          </div>
        </div>
        <div class="page_thumb">
          <div class="page_container cate_container">
            <swiper :options="swiperOption3" ref="mySwiper3" class="swiper_cate">      
                <swiper-slide class="slide_cate" v-for="(i,index) in giftCards" :key="index" >
                <div class="cate_tab pointer" @click="toPage('category',i.seo_term,i.brand_name)">
                  <el-image :src="i.brand_img_url" >
                    <div slot="error" class="image-slot flex_content">
                      <i class="err_img"></i>
                    </div>
                    <div slot="placeholder" class="image-slot flex_content">
                      Loading<span class="dot">...</span>
                    </div>
                  </el-image>
       
                  <div class="cate_tab_title">{{ i.brand_name }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="swiper-pagination2" slot="pagination" style="color:#000;"></div>
        </div>
        
      </div>
    </div> -->
    <!-- <div class="container" v-if="videoGame.length>0">
      <div class="page_width page_top">
        <div class="page_title" style="color:#000">
          <div class="title_name">Trending Games</div>
          <div class="title_tab flex_content pointer"> -->
            <!-- <div class="title_tab_text">Discover all</div> -->
            <!-- <div class="title_tab_icon iconfont icon-circle_chevron_right flex_content"></div> -->
          <!-- </div>
        </div> -->
        <!-- <div class="page_thumb">
          <div class="page_container cate_container">
            <swiper :options="swiperOption4" ref="mySwiper4" class="swiper_cate">      
                <swiper-slide class="slide_cate" v-for="(i,index) in videoGame" :key="index" >
              
                  <div class="cate_tab pointer" @click.native="toGame(i.url)">     
                  <el-image :src="i.image" >
                    <div slot="error" class="image-slot flex_content">
                      <i class="err_img">
                        <img src="../../assets/image/err.jpg" alt="">
                      </i>
                    </div>
                    <div slot="placeholder" class="image-slot flex_content">
                      Loading<span class="dot">...</span>
                    </div>
                  </el-image>
              
                  <div class="cate_tab_title">{{ i.name }}</div>
                  <div class="marks flex_col_content" @click="checkLock(i.icons)" v-if="i.lock">
                    <div class="marks_lock">
                      <img src="../../assets/image/suo.png" alt="">
                    </div>
                    <div class="marks_price flex_content">{{i.icons}}
                      <i class="flex_content"><svg t="1727340443326" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16427" width="16" height="16"><path d="M627.297444 73.795726l-252.991991 12.929474-150.698211 114.16925L109.437993 398.642233v228.338498l114.169249 197.74676 143.422504 114.170272 281.55656 11.306511 184.30768-100.281961 128.715547-222.941582V398.642233L847.440283 200.89445z" fill="#D8AB15" p-id="16428"></path><path d="M605.815177 85.913718H377.476679L179.729919 200.082968 65.559647 397.830751v228.338498l114.170272 197.74676 197.74676 114.169249h228.338498l197.74676-114.169249 114.170273-197.74676V397.830751l-114.170273-197.747783z" fill="#F4DB33" p-id="16429"></path><path d="M321.538669 291.831578l478.853065-90.937128-193.627952 383.194402z" fill="#F4EE6D" p-id="16430"></path><path d="M372.082832 938.897763l-50.544163-647.066185L62.389444 626.980731l110.559025 191.495382z" fill="#F4D533" p-id="16431"></path><path d="M608.986403 584.088852L374.305453 938.897763h234.68095z" fill="#F4D835" p-id="16432"></path><path d="M914.560984 626.980731l-305.574581-42.891879v354.808911l191.405331-114.170272z" fill="#F4D735" p-id="16433"></path><path d="M323.76129 291.831578l285.225113 292.257274-234.68095 354.808911z" fill="#F3E044" p-id="16434"></path><path d="M330.289983 291.831578l44.01547-205.106378-197.74676 114.16925L62.389444 398.642233v228.338498z" fill="#F4D12E" p-id="16435"></path><path d="M800.391734 200.89445L914.560984 398.642233v228.338498l-305.574581-42.891879z" fill="#F4DF44" p-id="16436"></path><path d="M585.425801 861.990163H397.866055L235.435639 768.211313 141.655765 605.779873V418.220127l93.779874-162.430416 162.430416-93.779874h187.559746l162.43144 93.779874 93.77885 162.430416V605.779873l-93.77885 162.43144-162.43144 93.77885z m-181.092451-24.136724h174.624133l151.229306-87.311554 87.311555-151.229307V424.687422l-87.311555-151.229307-151.229306-87.312578H404.33335l-151.229307 87.312578-87.312578 151.229307v174.624133l87.312578 151.229306 151.229307 87.312578z" fill="#B16A23" opacity=".29" p-id="16437"></path><path d="M367.029746 938.897763l281.55656 11.306511 184.30768-100.281961-32.502252-25.194822-191.405331 114.170272z" fill="#BE8516" p-id="16438"></path><path d="M627.297444 73.795726l-21.482267 12.117992 197.74676 114.16925 43.878346 0.811482z" fill="#D2BD33" p-id="16439"></path><path d="M494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#F4D033" p-id="16440"></path><path d="M645.203256 498.961032L501.179049 650.448212c-8.208962 8.580422-13.431917 8.580422-16.790408 8.580423-2.986007 0-8.582469 0-16.417925-8.580423L323.947532 498.961032s0-0.37146-0.373507-0.37146c-4.103458-5.970992-6.343475-13.059434-6.343475-19.775392s2.238994-13.43294 6.343475-17.909905l72.38561-77.236082c3.730974-3.731998 6.715959-5.969968 9.327436-7.089465 2.986007-1.119497 5.223978-1.119497 6.715959-1.119497h145.143705c3.358491 0 5.596462 0.74599 8.208962 2.238994 2.611477 1.490957 4.476965 3.357468 7.461949 6.343475l72.384587 76.862575c0.373507 0 0.373507 0 0.373507 0.37146 4.103458 4.851495 5.969968 11.567453 5.969968 18.284435 0 7.460925-2.237971 14.923898-5.969968 19.029402-0.372483-0.001023-0.372483 0.37146-0.372484 0.37146zM494.090607 643.732254l144.024207-151.486157c2.238994-2.612501 3.731998-7.462972 3.731998-12.685927 0-4.477988-1.119497-8.954953-3.359514-11.94096h-0.373507l-72.384587-76.861552c-2.238994-2.238994-3.731998-3.731998-5.223979-4.477988-1.119497-0.74599-2.238994-1.119497-3.731997-1.119497H412.004053c-0.74599 0-1.865487 0-2.986007 0.373507-1.490957 0.74599-3.357468 1.865487-5.969969 4.851495l-72.384587 77.235058c-2.612501 2.612501-3.731998 6.715959-3.731998 11.19497 0 4.850471 1.493004 9.700943 4.479012 13.804401L475.061205 643.7343c4.850471 5.596462 7.835456 5.596462 9.328459 5.596462 1.864464-0.002047 4.476965-0.002047 9.700943-5.598508z m0 0" fill="#ECBF1D" p-id="16441"></path><path d="M417.600515 470.977701c-1.493004-1.865487-1.493004-5.222955 0.74599-6.715958 1.866511-1.866511 4.850471-1.493004 6.716982 0.373506l59.326177 69.774133 60.818157-69.774133c1.865487-1.865487 4.850471-2.238994 7.089465-0.373506 1.866511 1.866511 1.866511 4.850471 0.373507 6.715958l-64.550155 73.877591-0.74599 0.747014a4.793166 4.793166 0 0 1-6.716982-0.747014l-63.057151-73.877591z m0 0" fill="#F5EC67" p-id="16442"></path><path d="M627.297444 73.795726L377.476679 85.913718h228.338498z" fill="#BE8516" p-id="16443"></path></svg></i>
                    </div>
                  </div>
                </div>            
              </swiper-slide>
            </swiper>
          </div>
          <div class="swiper-pagination3 " slot="pagination" style="color:#000;"></div>
        </div> -->
        
      <!-- </div> -->
    <!-- </div> -->
    <template>
      <el-dialog title="" :visible.sync="dialogVisible" width="30%" :show-close="false" top="20%">
      <span>Are you sure to spend {{ icons }} coins to unlock this game</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">cancel</el-button>
        <el-button type="primary" @click="isConfirm()">confirm</el-button>
      </span>
    </el-dialog>
    </template>
    
  </div>

</template>

<script>
import { swiper, swiperSlide,} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
    
  },
  data () {
    return {
      goods: [],
      showGoods: [],
      name: '',
      hoverIndex:null,
      menuList:[
        {name:'games',icon:'	https://assets.g2g.com/img/offer/cat_light_d3cf5b03-b80b-4f7e-bf97-ed359903de0b.webp',hoverIcon:'	https://assets.g2g.com/img/offer/cat_color_d3cf5b03-b80b-4f7e-bf97-ed359903de0b.webp',},
        {name:'game coins',icon:'	https://assets.g2g.com/img/offer/cat_light_3c2a9034-2569-4484-92ad-c00e384e7085.webp',hoverIcon:'https://assets.g2g.com/img/offer/cat_color_3c2a9034-2569-4484-92ad-c00e384e7085.webp',},
        {name:'items',icon:'https://assets.g2g.com/img/offer/cat_light_c508fb9f-a58e-4819-b815-c4684d8a2e70.webp',hoverIcon:'https://assets.g2g.com/img/offer/cat_color_c508fb9f-a58e-4819-b815-c4684d8a2e70.webp',},
        {name:'account',icon:'https://assets.g2g.com/img/offer/cat_light_5830014a-b974-45c6-9672-b51e83112fb7.webp',hoverIcon:'https://assets.g2g.com/img/offer/cat_color_5830014a-b974-45c6-9672-b51e83112fb7.webp',},
        {name:'skins',icon:'https://assets.g2g.com/img/offer/cat_light_6fd06182-b5a4-4d13-866a-46d39631a26d.webp',hoverIcon:'https://assets.g2g.com/img/offer/cat_color_6fd06182-b5a4-4d13-866a-46d39631a26d.webp',},
      ],
      screenWidth: document.body.clientWidth,
      swiperOption: {},
      mobileSwiper:false,
      swiperOption2: {},
      padSwiper:false,
      swiperOption3: {},
      swiperOption4: {},
      isFloat:false,
      markList:[
        {icon:'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA1MiA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUwLjA0MDMgMTJDNDUuNTcxMyAxMi4wNDUyIDQxLjEzOTUgMTEuMTgyMiAzNy4wMTQgOS40NjMyM0MzMi44ODg1IDcuNzQ0MjYgMjkuMTU1MSA1LjIwNTE4IDI2LjA0MDMgMkMyMi45MjU2IDUuMjA1MTggMTkuMTkyMiA3Ljc0NDI2IDE1LjA2NjcgOS40NjMyM0MxMC45NDEyIDExLjE4MjIgNi41MDk0NSAxMi4wNDUyIDIuMDQwMzUgMTJDMi4wNDAzNSAxMiAtMC4wNTk2NTIzIDQ4IDI2LjA0MDMgNjJDNTIuMTQwMyA0OCA1MC4wNDAzIDEyIDUwLjA0MDMgMTJaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzkuMDQwNSAyNEwyNS4wNDA1IDM4TDE4LjA0MDUgMzEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=',title:'Secure Transactions',msg:'Feel confident each time you transact with us. GamerProtect comes with SSL protection and wide range of payment processors under a safe and secured platform.'},
        {icon:"data:image/svg+xml;base64,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", 
        title:'Customer Support',msg:'Our dedicated Customer Service team are available to help with any queries about your orders and provide exceptional after-sales support.'},
        {icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjYzMzIgMjguODY2OEMyNC40ODY3IDI4Ljg2NjggMjYuNzk5OSAyNi41NTM2IDI2Ljc5OTkgMjMuNzAwMUMyNi43OTk5IDIwLjg0NjYgMjQuNDg2NyAxOC41MzM0IDIxLjYzMzIgMTguNTMzNEMxOC43Nzk3IDE4LjUzMzQgMTYuNDY2NiAyMC44NDY2IDE2LjQ2NjYgMjMuNzAwMUMxNi40NjY2IDI2LjU1MzYgMTguNzc5NyAyOC44NjY4IDIxLjYzMzIgMjguODY2OFoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik00NC4zNjY2IDQ3LjQ2NjZDNDcuMjIwMSA0Ny40NjY2IDQ5LjUzMzMgNDUuMTUzNCA0OS41MzMzIDQyLjNDNDkuNTMzMyAzOS40NDY1IDQ3LjIyMDEgMzcuMTMzMyA0NC4zNjY2IDM3LjEzMzNDNDEuNTEzMSAzNy4xMzMzIDM5LjIgMzkuNDQ2NSAzOS4yIDQyLjNDMzkuMiA0NS4xNTM0IDQxLjUxMzEgNDcuNDY2NiA0NC4zNjY2IDQ3LjQ2NjZaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNDcuNDY2OCAxOC41MzM0TDE4LjUzMzQgNDcuNDY2OCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTMzIDQuNTgzMzNMMzkuMiAyTDQzLjg1IDYuNzUzMzNINTAuNTY2N0w1My4xNSAxMi44NUw1OS4yNDY3IDE1LjQzMzNWMjIuMTVMNjQgMjYuOEw2MS40MTY3IDMzTDY0IDM5LjJMNTkuMjQ2NyA0My44NVY1MC41NjY3TDUzLjE1IDUzLjE1TDUwLjU2NjcgNTkuMjQ2N0g0My44NUwzOS4yIDY0TDMzIDYxLjQxNjdMMjYuOCA2NEwyMi4xNSA1OS4yNDY3SDE1LjQzMzNMMTIuODUgNTMuMTVMNi43NTMzMyA1MC41NjY3VjQzLjg1TDIgMzkuMkw0LjU4MzMzIDMzTDIgMjYuOEw2Ljc1MzMzIDIyLjE1VjE1LjQzMzNMMTIuODUgMTIuODVMMTUuNDMzMyA2Ljc1MzMzSDIyLjE1TDI2LjggMkwzMyA0LjU4MzMzWiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPC9zdmc+Cg==",title:'Best Offers',msg:'Jinovationgame provides competitive pricing to the buyers driven by a free market economy while striving to keep the cost low for our sellers.'},
      ],
    
      giftCards:[],
      dialogVisible:false,
      icons:0,
      checkLockItem:{}
    }
  },
  created () {
    this.$store.state.isFloat = false
    this.name = this.$store.state.page
    // this.setOptions4()
    this.setOptions2()
  },
  methods: {
  
    setOptions4(){
      this.swiperOption4 = {
        loop: false,
        autoplay: false,
        slidesPerView:4,
        slidesPerGroup:4,
        spaceBetween: 50,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
          el:'.swiper-pagination3 ',
          clickable:true
        },
        breakpoints: { 
          //当宽度小于等于320
          767: {
            slidesPerView: 2,
            spaceBetween: 24,
            slidesPerGroup:2,
            pagination:{
              el:'.swiper-pagination3',
              type :'fraction',
            },
          },
        //当宽度小于等于480
          991: { 
            slidesPerView: 3,
            slidesPerGroup:3,
            spaceBetween: 24,   
            pagination:{
              el:'.swiper-pagination3',
              type :'fraction',
            },
          },
        },
      }

    },
    setOptions2(){
      this.swiperOption2 = {
        loop: false,
        autoplay: false,
        slidesPerView:4,
        slidesPerColumnFill:'row',
        slidesPerColumn:2,
        spaceBetween: 50,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
              el:'.swiper-pagination',
              type :'fraction',
            },
        breakpoints: { 
          //当宽度小于等于320
          767: {
            slidesPerView: 2,
            spaceBetween: 24,
            slidesPerGroup:4,
          },
        //当宽度小于等于480
          991: { 
            slidesPerView: 3,
            spaceBetween: 24,   
          },
        },
      }
    },
    windowScroll() {
    // 滚动条距离页面顶部的距离
    // 以下写法原生兼容
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(scrollTop > 0){
      this.$store.state.isFloat = true
    }else{
      this.$store.state.isFloat = false
    }

    },
    toPage(e,name,title){
      if(e=='category'){
          this.$router.push('/'+e+'?seo_term='+name+'&title='+title)
          return
        }
      if(name){
        this.$router.push('/'+e+'?title='+name)
        return
      }
      this.$router.push('/'+e)
    },
  
    toGame(url){ 
      window.open(url, '_blank');
    },
    checkLock(item){
      // this.$Message.warning('')
      let isLogin = this.isLogin
      if(!isLogin){
        this.$Message.warning('Please login')
        return
      }
      this.icons = item.icons
      this.checkLockItem = item
      this.dialogVisible = true
     
    },
    isConfirm(){
      let that = this
      let userInfo = this.userInfo
      let icons =Number(this.icons) 
      let userIcons = Number(userInfo.coins)
      let userGames = this.$store.state.userGames
      let checkLockItem = this.checkLockItem
      let games = this.videoGame

      let _this = this
      if(userIcons>icons){
        userInfo.coins = userIcons - icons
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(()=>{
          loading.close()
          games.map(v=>{
            if(v.id == checkLockItem.id){
               v.lock = false
             }
          })
          userGames.push(checkLockItem)
          _this.$store.commit('setUserGames',userGames)
          _this.$store.commit('setVideoGame',games)
          _this.$store.commit('setUserInfo',userInfo)
          _this.$Message.success('Successful purchase')
        },1000)

      }else{
        this.$confirm('Insufficient coins, please recharge',{
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel',
        })
        .then(_ => {
          that.$router.push('/recharge')
        })
        .catch(_ => {});
      }
      this.dialogVisible = false
    }

    
    
  },
  mounted () {
    window.onresize = () => {
      this.screenWidth = window.innerWidth
    },
    window.addEventListener('scroll', this.windowScroll);
    
  },
  computed:{
    isLogin(){ return this.$store.state.isLogin },
    userInfo(){ return this.$store.state.userInfo },
    videoGame(){ return this.$store.state.videoGame}
  },
  watch: {
    // "$store.state.page": {
    //   handler: function (newVal) {
    //     this.name = newVal
    
    //   }
    // },
    
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScroll);
  },


  
}
</script>
<style lang='scss' scoped>
.index {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color:#fff;
  // background: url(../assets/picture/bg.jpg) no-repeat ;\
  .banner{
    background: linear-gradient(180deg, #ff6230 -2.82%, #db1e0c 56.82%, #a01003);
    height: 550px;
    
    .banner_left{
      position: absolute;
      top: 200px;
      z-index: 1;
      .left_top{
        font-family: Roboto Flex;
        font-size: 30px;
        font-weight: 300;
        line-height: 1;
        text-align: left;
      }
      .left_bottom{
        font-family: Ropa Sans;
        font-size: 80px;
        font-weight: 400;
        line-height: 80px;
        text-align: left;
      }
    }
    .banner_right{
      width: 500px;
      right: 0px;
      position: absolute;
      top:50px;
      z-index: 1;
    }
    .menu{
      position: absolute;
      left:0;
      right:0;
      height:102px;
      bottom:0;
      .slide_tab{
        height:102px;
        text-transform: capitalize;
        .tab_icon{
          width:40px;
          height: 40px;
          background-size: cover;
        }
        .tab_text{
          margin:10px 0 8px;
          padding:0 8px;
          font-size: 14px;
        }
        &:hover{
          background-color: #fff;
          border-radius: 10px 10px 0 0 ;
          color:#000;
          
        }
      }
    }
  }
  .page_top{
    margin-top:48px;
  }
  .page_back{
    background-color: #2e4965;
    padding:24px 0px;
    border-radius: 24px;
  
  }
  .cate_thumb{
    padding:0 50px 24px;
    
  }
  .cate_container{
      padding:30px 0 20px;
    
     
  }
  .h_full{
    background: linear-gradient(235.63deg, rgb(84, 155, 239) 15.78%, rgb(91, 104, 223) 84.1%);
    min-height: 380px;
    margin-top:48px;
    .h_page_width{
      padding-top:48px;
      padding-bottom:48px;
      .h_title{
        font-size: 1.875rem;
        color:#fff;
        margin-bottom:8px;
        text-align: center;
        font-weight: 600;
        line-height: 2rem;
      }
      .h_container{
       .h_thumb{
        padding-top:48px;
       }
        .h_thumb_icon{
          height:64px;
          width:64px;
          margin-bottom:16px;
        }
        .h_thumb_name{
          font-size:20px;
          font-weight: 500;
        }
        .h_thumb_msg{
          font-size:12px;
          margin-top:8px;
        }
      }
    }
  }
 
}
</style>